// extracted by mini-css-extract-plugin
module.exports = {"shortcut":"FloatingButton_shortcut__ZhuTP","visible":"FloatingButton_visible__gd6Ue","pdp_shortcut":"FloatingButton_pdp_shortcut__pnaSd"};